<template>
	<v-expansion-panel>
		<v-expansion-panel-header expand-icon="" color="secondary">
			<v-toolbar rounded color="secondary" elevation="0" :outlined="false" dense class="pt-0 pb-0 mr-0 ml-0 font-weight-bold white--text justify-center text-center"
				><v-spacer></v-spacer><v-toolbar-title class="justify-center text-center" style="font-size: 32px">{{ title }}</v-toolbar-title
				><v-spacer></v-spacer
			></v-toolbar>
		</v-expansion-panel-header>
		<v-expansion-panel-content class="mx-auto justify-center text-center ml-5 mr-5 mt-5">
			<v-card-text class="justify-center text-center">
				<v-row class="justify-left text-center">
					<v-col cols="6">
						<v-card v-if="'weekdays' in company.working_hours && company.working_hours.weekdays" class="pa-2" elevation="0" outlined>
							<v-row class="justify-left text-center">
								<v-col cols="12">
									<v-list-item-title>Weekdays</v-list-item-title>
								</v-col>
								<v-col cols="6" class="pb-0 mb-0">
									<time-picker-dialog
										:toggled="true"
										:initial="company.working_hours.weekdays.start"
										label="Start"
										@input="OnWeekdayStartTimeInput"
									></time-picker-dialog>
									<!-- <v-date outlined :append-icon="readonly['workingHours.weekdays.start'] ? 'mode_edit' : 'done'" @click:append="readonly['workingHours.weekdays.start'] ? edit('workingHours.weekdays.start') : finished('workingHours.weekdays.start')" :readonly="readonly['workingHours.weekdays.start']" label="Weekdays Start" :v-model="company.working_hours.weekdays.start" :value="company.working_hours.weekdays.start"></v-time-picker> -->
								</v-col>
								<v-col cols="6" class="pb-0 mb-0">
									<time-picker-dialog
										:toggled="true"
										:initial="company.working_hours.weekdays.end"
										label="End"
										@input="OnWeekdayEndTimeInput"
									></time-picker-dialog>
									<!-- <v-date outlined :append-icon="readonly['workingHours.weekdays.start'] ? 'mode_edit' : 'done'" @click:append="readonly['workingHours.weekdays.start'] ? edit('workingHours.weekdays.start') : finished('workingHours.weekdays.start')" :readonly="readonly['workingHours.weekdays.start']" label="Weekdays Start" :v-model="company.working_hours.weekdays.start" :value="company.working_hours.weekdays.start"></v-time-picker> -->
								</v-col>
								<v-col cols="12" class="pt-0 mt-0">
									<v-btn
										class="pt-0 mt-0"
										color="primary"
										@click="
											() => {
												company.working_hours.weekdays = null;
											}
										"
										>Mark practice as closed on weekdays</v-btn
									>
								</v-col>
							</v-row>
						</v-card>
						<v-card v-else elevation="0" outlined>
							<v-col cols="12">
								<v-list-item-title>Practice is not open weekdays</v-list-item-title>
								<v-btn
									class="mt-2"
									color="primary"
									@click="
										() => {
											company.working_hours.weekdays = { start: '09:00', end: '17:00' };
										}
									"
									>Mark practice as open on weekdays</v-btn
								>
							</v-col>
						</v-card>
					</v-col>

					<v-col cols="6">
						<v-card v-if="'saturday' in company.working_hours && company.working_hours.saturday" class="pa-2" elevation="0" outlined>
							<v-row class="justify-left text-center">
								<v-col cols="12">
									<v-list-item-title>Saturdays</v-list-item-title>
								</v-col>
								<v-col cols="6" class="pb-0 mb-0">
									<time-picker-dialog
										:toggled="true"
										:initial="company.working_hours.saturday.start"
										label="Start"
										@input="OnSaturdayStartTimeInput"
									></time-picker-dialog>
								</v-col>
								<v-col cols="6" class="pb-0 mb-0">
									<time-picker-dialog
										:toggled="true"
										:initial="company.working_hours.saturday.end"
										label="End"
										@input="OnSaturdayEndTimeInput"
									></time-picker-dialog>
								</v-col>
								<v-col cols="12" class="pt-0 mt-0">
									<v-btn
										class="pt-0 mt-0"
										color="primary"
										@click="
											() => {
												company.working_hours.saturday = null;
											}
										"
										>Mark practice as closed on Saturdays</v-btn
									>
								</v-col>
							</v-row>
						</v-card>
						<v-card v-else elevation="0" outlined>
							<v-col cols="12">
								<v-list-item-title>Practice is not open Saturdays</v-list-item-title>
								<v-btn
									class="mt-2"
									color="primary"
									@click="
										() => {
											company.working_hours.saturday = { start: '09:00', end: '17:00' };
										}
									"
									>Mark practice as open on Saturdays</v-btn
								>
							</v-col>
						</v-card>
					</v-col>

					<v-col cols="6">
						<v-card v-if="'sunday' in company.working_hours && company.working_hours.sunday" class="pa-2" elevation="0" outlined>
							<v-row class="justify-left text-center">
								<v-col cols="12">
									<v-list-item-title>Sundays</v-list-item-title>
								</v-col>
								<v-col cols="6" class="pb-0 mb-0">
									<time-picker-dialog
										:toggled="true"
										:initial="company.working_hours.sunday.start"
										label="Start"
										@input="OnSundayStartTimeInput"
									></time-picker-dialog>
								</v-col>
								<v-col cols="6" class="pb-0 mb-0">
									<time-picker-dialog :toggled="true" :initial="company.working_hours.sunday.end" label="End" @input="OnSundayEndTimeInput"></time-picker-dialog>
								</v-col>
								<v-col cols="12" class="pt-0 mt-0">
									<v-btn
										class="pt-0 mt-0"
										color="primary"
										@click="
											() => {
												company.working_hours.sunday = null;
												$forceUpdate();
											}
										"
										>Mark practice as closed on Sundays</v-btn
									>
								</v-col>
							</v-row>
						</v-card>
						<v-card v-else elevation="0" outlined>
							<v-col cols="12">
								<v-list-item-title>Practice is not open Sundays</v-list-item-title>
								<v-btn
									class="mt-2"
									color="primary"
									@click="
										() => {
											company.working_hours.sunday = { start: '09:00', end: '17:00' };
											$forceUpdate();
										}
									"
									>Mark practice as open on Sundays</v-btn
								>
							</v-col>
						</v-card>
					</v-col>

					<v-col cols="6">
						<v-card v-if="'public_holiday' in company.working_hours && company.working_hours.public_holiday" class="pa-2" elevation="0" outlined>
							<v-row class="justify-left text-center">
								<v-col cols="12">
									<v-list-item-title>Public Holidays</v-list-item-title>
								</v-col>
								<v-col cols="6" class="pb-0 mb-0">
									<time-picker-dialog
										:toggled="true"
										:initial="company.working_hours.public_holiday.start"
										label="Start"
										@input="OnHolidayStartTimeInput"
									></time-picker-dialog>
								</v-col>
								<v-col cols="6" class="pb-0 mb-0">
									<time-picker-dialog
										:toggled="true"
										:initial="company.working_hours.public_holiday.end"
										label="End"
										@input="OnHolidayEndTimeInput"
									></time-picker-dialog>
								</v-col>
								<v-col cols="12" class="pt-0 mt-0">
									<v-btn
										class="pt-0 mt-0"
										color="primary"
										@click="
											() => {
												company.working_hours.public_holiday = null;
												$forceUpdate();
											}
										"
										>Mark practice as closed on Holidays</v-btn
									>
								</v-col>
							</v-row>
						</v-card>
						<v-card v-else elevation="0" outlined>
							<v-col cols="12">
								<v-list-item-title>Practice is not open on Public Holidays</v-list-item-title>
								<v-btn
									class="mt-2"
									color="primary"
									@click="
										() => {
											company.working_hours.public_holiday = { start: '09:00', end: '17:00' };
											$forceUpdate();
										}
									"
									>Mark practice as open on Holidays</v-btn
								>
							</v-col>
						</v-card>
					</v-col>

					<v-col cols="6">
						<v-select
							v-model="company.languages"
							label="Enter the preferred languages"
							outlined
							multiple
							chips
							:items="languagesOptions"
							:rules="languagesPreferredRules"
						></v-select>
					</v-col>
				</v-row>
			</v-card-text>
		</v-expansion-panel-content>
	</v-expansion-panel>
</template>

<script>
import timePickerDialog from '@/components/custom/TimePickerDialog.vue';
import store from '@/store';

export default {
	name: 'AdminViewPracticeBusinessOperationsCard',
	components: {
		timePickerDialog,
	},
	props: {
		company: { type: Object, optional: false, required: true },
	},
	data: () => ({
		title: 'Business Operations',
		readonly: {},
		languagesOptions: [],
	}),
	mounted() {
		this.UpdateLanguagesOptions();
	},
	methods: {
		UpdateLanguagesOptions() {
			this.languagesOptions = store.getters.configs.languages;
		},
		OnWeekdayStartTimeInput(value) {
			this.company.working_hours.weekdays.start = value;
			//On change axios to api here
		},
		OnWeekdayEndTimeInput(value) {
			this.company.working_hours.weekdays.end = value;
		},

		OnSaturdayStartTimeInput(value) {
			this.company.working_hours.saturday.start = value;
		},
		OnSaturdayEndTimeInput(value) {
			this.company.working_hours.saturday.end = value;
		},

		OnSundayStartTimeInput(value) {
			this.company.working_hours.sunday.start = value;
		},
		OnSundayEndTimeInput(value) {
			this.company.working_hours.sunday.end = value;
		},

		OnHolidayStartTimeInput(value) {
			this.company.working_hours.public_holiday.start = value;
		},
		OnHolidayEndTimeInput(value) {
			this.company.working_hours.public_holiday.end = value;
		},
		edit(key) {
			Object.keys(this.readonly)
				.filter(k => k != key && !this.readonly[k])
				.forEach(k => this.finished(k));
			this.readonly[key] = false;
			this.$forceUpdate();
		},
		finished(key) {
			this.readonly[key] = true;
			this.$forceUpdate();
		},
	},
};
</script>
